// @flow

export const getCookie = (name: string) => {
  if (typeof document === 'undefined' || !name) return;

  let cookies = document.cookie ? document.cookie.split('; ') : [];
  let result;
  for (let i = 0; i < cookies.length; i++) {
    let parts = cookies[i].split('=');
    let value = parts.slice(1).join('=');
    try {
      let found = decodeURIComponent(parts[0]);
      if (name === found) {
        result = value;
        break;
      }
    } catch (e) {}
  }
  if (!result) return undefined;
  return result;
};

export const setCookie = (name: string, value: any) => {
  if (typeof document === 'undefined') return;
  document.cookie =
    name +
    '=' +
    value +
    '; expires=' +
    new Date(Date.now() + 365 * 864e5).toUTCString() +
    '; path=/';
};
